export default __webpack_public_path__ + "static/media/0181_IMG5174.b95976f9.jpg";